import { makeStyles } from "@mui/styles";

export const tabulatorStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
    color: '#004F9F',
    width: '100%',
    alignSelf: 'center',
    marginLeft: 14
  },
  border: {
    borderRadius: 6,
    marginTop: 10,
    marginBottom: 4,
    width: '100%', 
    boxShadow: 3
  },
  bad: {
    background: 'linear-gradient(125deg, rgba(238, 238, 238 ,1) 90%, rgba(246,104,94,1) 100%)'
  },
  good: {
    background: 'linear-gradient(125deg, rgba(238, 238, 238 ,1) 90%, rgb(165, 255, 168) 100%)'
  },
  box: {
    minHeight: 64,
    width: '100%',
    padding: 6,
    display: 'flex',
    backgroundColor: 'rgba(242, 242, 242 ,1)',
    alignItems: 'center',
    justifyContent: 'space-between'    
  }
}));